module.exports = __webpack_public_path__ + "img/4_x8.69ecc7b1.png";